import axios from 'axios';
import Cookies from 'js-cookie';
import { useEffect, useState } from 'react';
import { Button, Card, Col, Container, Pagination, Row, Spinner } from 'react-bootstrap';
import i18n from '../contexts/I18n';
import { useTranslation } from 'react-i18next';


const Blog = () => {
  // I18N
  const { t } = useTranslation();
  const savedLang = Cookies.get('language');
  const [locale, setLocale] = useState("en");
  // PAGINATION
  const [page, setPage] = useState(1);
  const [pageTokens, setPageTokens] = useState([null]);
  const [totalPagination, setTotalPagination] = useState(1);
  const [currentPageIndex, setCurrentPageIndex] = useState(1);
  const [hasMorePages, setHasMorePages] = useState(true);
  const [loading, setLoading] = useState(true);
  // const [page, setPage] = useState(1);
  // const [hasNext, setHasNext] = useState(false);
  // const [hasPrevious, setHasPrevious] = useState(false);
  // const [totalPage, setTotalPage] = useState(0);
  // BLOG SETTINGS
  const [posts, setPosts] = useState([]);
  // SEARCH SETTINGS
  const [query, setQuery] = useState('');

  useEffect(() => {
    document.title = t('title.blog');
  }, []);

  useEffect(() => {
    const savedLang = Cookies.get('language');
    if (savedLang !== locale) {
      i18n.changeLanguage(savedLang);
      setLocale(savedLang);
    }
  }, [i18n, t]);

  useEffect(() => {
    const fetchPosts = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`/api/posts/?page=${currentPageIndex}`);
        // setHasNext(page < response.data.has_next);
        // setHasPrevious(response.data.has_previous);
        setPosts(response.data.posts);
        setHasMorePages(response.data.has_next);
        setTotalPagination(response.data.total_pages);
      } catch (error) {
        console.error("Erreur lors du chargement des posts :", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPosts();
  }, [currentPageIndex]);

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    try {
      // POST vers ton endpoint Django (tu peux adapter l’URL)
      const response = await axios.post('/api/posts/search/', { query });

      // faire quelque chose avec les résultats
      // console.log('Résultats :', response.data);
      setPosts(response.data.posts);
      setHasMorePages(response.data.has_next);
      setTotalPagination(response.data.total_pages);
      // setHasNext(response.data.has_next);
      // setHasPrevious(response.data.has_previous);
      // setTotalPage(response.data.total_pages);
    } catch (error) {
      console.error('Erreur lors de la recherche :', error);
    }
  };

  // <div className="spinnerContainer">
  //     <Spinner animation="border" role="status" className="spinner">
  //         <span className="visually-hidden">Loading...</span>
  //     </Spinner>   
  // </div>
  return (
    <>
      <Container fluid className="card-container" >
        <div id="search_container">
          <form id="search_form" onSubmit={handleSubmit}>
            <input
              id="title_search"
              type="text"
              name="query"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder={t('blog.searchPlaceholder')}
            />

            <button id="post_submit_btn" className="submit-btn" type="submit">
              Search
            </button>

            <div className="search_icon" onClick={handleSubmit}>
              <img src="/blog/search_icon.svg" className="fi fi-sr-pencil" alt="Search" />
            </div>
          </form>
        </div>

        <div style={{position: 'relative', flex: 'none'}} >
          <div id="wave-container" >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" style={{ transform: 'scaleY(-1)' }}>
              <path fill="#b0b3f7" fillOpacity="1" d="M0,160L48,160C96,160,192,160,288,176C384,192,480,224,576,218.7C672,213,768,171,864,133.3C960,96,1056,64,1152,48C1248,32,1344,32,1392,32L1440,32L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z">
              </path>
            </svg>
          </div>
        </div>
        <h1 className="text-center my-5 bg_gradient_text">{t('navBar.news')}</h1>

    <Row className="justify-content-center p-3">
      <Col md={8}>
        {posts.map((post: any) => {
          
          // Corrige en JSON valide en remplaçant les clés non-quotées
          // const fixedTitle = post.title.replace(/([{\s,])(\w+):/g, '$1"$2":');
          const fixedTitle = post.title.replace(/[\r\n]+/g, '');
          // const fixedContent = post.content.replace(/([{\s,])(\w+):/g, '$1"$2":');
          const fixedContent = post.content.replace(/[\r\n]+/g, '');
          const title = JSON.parse(fixedTitle);
          const content = JSON.parse(fixedContent);
          const pubDate = new Date(post.pub_date);
          const month = pubDate.toLocaleString(locale, { month: 'long' });
          const day = pubDate.getDate();
          // const year = pubDate.getFullYear();
          return (
            <Card key={post.id} className="mb-4 shadow-sm">
              <Card.Body>
                {post.url === "blank" ? (
                  <Card.Title className="pb-3" style={{textAlign: 'center'}}>{title[locale]}</Card.Title>
                ) : (
                  <Card.Link href={post.url} target="_blank" rel="noopener noreferrer" className="pb-3" style={{textAlign: 'center', display: "block"}}>
                    {title[locale]}
                  </Card.Link>
                )}
                <Card.Text>
                  <p dangerouslySetInnerHTML={{ __html: content[locale] }} />
                </Card.Text>
                <Card.Footer className="text-muted" style={{minHeight: 75}}>
                  <div className="the_month">
                    <span style={{ color: "#FFF" }}>{month}</span>
                    <div className="the_day">
                      <span style={{ fontSize: "16px", lineHeight: "30px" }}>{day}</span>
                    </div>
                  </div>
                  <span style={{float: 'right'}}>{post.author}</span>
                </Card.Footer>
              </Card.Body>
            </Card>
          );
        })}

        <Pagination className="justify-content-center mt-4">
          <Pagination.Prev
            onClick={() => setCurrentPageIndex((prev) => Math.max(prev - 1, 1))}
            disabled={currentPageIndex === 1}
          />
          {[...Array(totalPagination)].map((_, idx) => (
            <Pagination.Item
              key={idx + 1}
              active={currentPageIndex === idx + 1}
              onClick={() => setCurrentPageIndex(idx + 1)}
            >
              {idx + 1}
            </Pagination.Item>
          ))}
          <Pagination.Next
            onClick={() => setCurrentPageIndex((prev) => Math.min(prev + 1, totalPagination))}
            disabled={currentPageIndex === totalPagination}
          />
        </Pagination>

        {/* <div className="d-flex justify-content-between mt-4">
          <p>{totalPage}</p>
          {hasPrevious && (
            <Button variant="secondary" onClick={() => setPage(page - 1)}>
              Précédent
            </Button>
          )}
          {hasNext && (
            <Button variant="primary" onClick={() => setPage(page + 1)}>
              Suivant
            </Button>
          )}
        </div> */}
      </Col>
    </Row>
        <div style={{position: 'relative', flex: 'none'}} >
          <div id="wave-container" >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
              <path fill="#b0b3f7" fillOpacity="1" d="M0,160L48,160C96,160,192,160,288,176C384,192,480,224,576,218.7C672,213,768,171,864,133.3C960,96,1056,64,1152,48C1248,32,1344,32,1392,32L1440,32L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z">
              </path>
            </svg>
          </div>
        </div>
      </Container>
    </>
  )
};
  
export default Blog;